import {
  registerAttrTrackingMap,
  setupAttrTracking,
} from '@unisporkal/attr-tracking';

import { searchAttrTrackingMap } from './attrTrackingMap';

export const initAttrTracking = () => {
  if (typeof window !== 'undefined') {
    registerAttrTrackingMap(searchAttrTrackingMap);
    setupAttrTracking();
  }
};
